/**
 * Created by Karol Kluska on 26.09.17.
 */

angular.module("app").component("guest", {
  templateUrl: "app/components/guest/Guest.html",
  controller: Guest,
});
/** @ngInject */
// eslint-disable-next-line
function Guest(
  $rootScope,
  Params,
  Restangular,
  OffersManager,
  OffersParser,
  $state,
  ENV,
  Currency,
  $translate,
  $uibModal,
  GTMManager,
  ConfigBookingEngine,
  ConfigHotel,
  AGE_CATEGORY,
  $window
) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.Params = Params;
  $this.Restangular = Restangular;
  $this.OffersParser = OffersParser;
  $this.OffersManager = angular.copy(OffersManager);
  $this.$state = $state;
  $this.ENV = ENV;
  $this.Currency = Currency;
  $this.$translate = $translate;
  $this.$uibModal = $uibModal;
  $this.GTMManager = GTMManager;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.ConfigHotel = ConfigHotel;
  $this.ageCategories = ConfigBookingEngine.getAgeCategories();
  $this.AGE_CATEGORY = AGE_CATEGORY;
  $this.$window = $window;
  $this.isPanelEdited = false;
  $this.cart = [];
  $this.comments = "";
  $this.gatewayName = null;
  $this.validationFullNamePattern = "^[^\\s]{2,}\\s[^\\s]{1,}.*$";
  $this.validationEmailPattern =
    "(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$)";
  $this.validationPhonePattern = "^[0-9 \\(\\)+-]{4,20}$";
}

Guest.prototype = {
  $onInit: function () {
    this.viewType = this.Params.getViewType();
    this.userHash = this.Params.getUserHash();
    this.hotelId = this.Params.getHotelId();
    this.language = this.Params.getLanguage();
    this.checkIn = this.Params.getCheckIn();
    this.checkOut = this.Params.getCheckOut();
    this.occupancy = this.Params.getOccupancy();
    this.addons = this.Params.getAddons();
    this.discountCode = this.Params.getDiscountCode();
    this.cart = this.Params.getCart() || [];
    var lengthOfStay = moment(this.checkOut).diff(this.checkIn, "days");
    this.OffersManager.setLengthOfStay(lengthOfStay);
    this.OffersManager.setMinPersons(null);
    this.OffersManager.setRoomGroupId(null);
    this.OffersManager.setRateplanId(null);
    this.OffersManager.setOnlyAvailableRooms(true);
    this.OffersManager.setOnlyAvailableRateplans(true);
    this.countries = [];
    this.getOffers();
    this.getPaymentMethods();
    this.getISO2Countries();
  },

  getOffers: function () {
    var $this = this;
    $this.$rootScope.$emit("startLoading", {
      title: this.$translate.instant("loader.PLEASE_WAIT"),
      description: this.$translate.instant("loader.AVAILABILITY"),
    });

    /* eslint-disable camelcase */
    var requestParams = {
      start: moment($this.checkIn).format("YYYY-MM-DD"),
      end: moment($this.checkOut).subtract(1, "day").format("YYYY-MM-DD"),
      hotel_id: this.hotelId,
      language: this.language,
      discount_code_name: this.discountCode,
    };
    /* eslint-enable camelcase */
    $this.Restangular.all("")
      .customGET(
        "bookingengine/api/be/preorders?" + this.getItemsForApiGet(),
        requestParams
      )
      .then(function (preOrder) {
        $this.priceSummary = preOrder.summary;
        $this.fullOffersList = $this.OffersParser.parse(preOrder.offers);
        $this.filteredOffersList = $this.OffersManager.getAvailable(
          $this.fullOffersList
        );
        $this.GTMManager.setBeginCheckoutEvent($this.filteredOffersList);
        $this.summary = $this.getSummary(preOrder.offers);
      })
      .catch(function (e) {
        $this.$state.go("booking.clientErrors", {}, { location: false });
      })
      .finally(function () {
        $this.$rootScope.$emit("stopLoading");
      });
  },

  getISO2Countries: function () {
    var $this = this;
    var currentLanguageCode = $this.$translate.use();
    $this.Restangular.all("").customGET('be/assets/countries/' + currentLanguageCode + '.json')
      .then(function (data) {
        if (data.countries) {
          var countriesList = data.countries;
          Object.keys(countriesList).sort(function(a,b) {
            if (countriesList[a] < countriesList[b]) {
              return -1;
            }
            if (countriesList[a] > countriesList[b]) {
              return 1;
            }
            return 0;
          }).map((key) => $this.countries[key] = countriesList[key]);
        }
      })
      .catch(function (error) {
        var data = {
          "AF": "Afganistan",
          "AL": "Albania",
          "DZ": "Algieria"
        }
        $this.countries = [];
        Object.keys(data).sort(function(a,b) {
          if (data[a] < data[b]) {
            return -1;
          }
          if (data[a] > data[b]) {
            return 1;
          }
          return 0;
        }).map((key) => $this.countries[key] = data[key]);
      })
  },

  isValidForm: function (form) {
    if (form.$valid) {
      return true;
    }

    angular
      .element("[name='" + form.$name + "']")
      .find(".ng-invalid:visible:first")
      .focus();
    return false;
  },

  getPaymentMethods: function () {
    var $this = this;
    $this.Restangular.all("bookingengine/api/be/hotels/" + this.hotelId + "/gateways")
      .getList()
      .then(function (paymentMethods) {
        $this.paymentMethods = paymentMethods.sort(sortPaymentMethods);
        $this.paymentMethods = $this.paymentMethods.map(addMissingProps);
        if (paymentMethods.length === 0) {
          /* eslint-disable camelcase */
          $this.paymentMethods = [
            {
              name: $this.$translate.instant(
                "guest.payment_methods.DEFAULT_GATEWAY"
              ),
              gateway_name: "offline",
            },
          ];
          /* eslint-enable camelcase */
        }
        if (paymentMethods.length === 1) {
          $this.gatewayName = $this.paymentMethods[0].gateway_name;
        }
      })
      .catch(function () {
        console.error("gateway errors ");
        $this.$state.go("booking.clientErrors", {}, { location: false });
      });

    function addMissingProps(item) {
      //temporary solutions untill cloud backend returns proper object
      item.factory_name = item.gatewayName;
      item.gateway_name = item.gatewayName;
      return item;
    }

    function sortPaymentMethods(a, b) {
      if (a.position < b.position) {
        return -1;
      }
      if (a.position > b.position) {
        return 1;
      }
      return 0;
    }
  },

  getSummary: function (offers) {
    var result = {};
    result.items = [];
    for (var i = 0; i < this.cart.length; i++) {
      var cartItem = this.cart[i];
      var addons = offers[i].add_ons || [];

      var offer = this.searchItemInOffers(
        cartItem.roomId,
        cartItem.rateplanId,
        cartItem.persons,
        addons
      );
      result.items.push(offer);
    }
    return this.isValidSummary(result) ? result : null;
  },

  isValidSummary: function (summary) {
    if (!angular.isArray(summary.items)) {
      return false;
    }

    if (summary.items.length === 0) {
      return false;
    }

    for (var i = 0; i < summary.items.length; i++) {
      var item = summary.items[i];
      if (item === null || angular.isUndefined(item)) {
        return false;
      }

      if (item.room === null || angular.isUndefined(item.room)) {
        return false;
      }

      if (item.rateplan === null || angular.isUndefined(item.rateplan)) {
        return false;
      }

      if (item.prices === null || angular.isUndefined(item.prices)) {
        return false;
      }
    }

    return true;
  },

  hasDiscount: function () {
    if (this.priceSummary.discount_price === null) {
      return false;
    }

    var price = this.priceSummary.price - this.priceSummary.discount_price;
    return price > 0;
  },

  getDiscountTotal: function () {
    if (this.priceSummary.discount_price === null) {
      return this.Currency.getFormattedPrice(0);
    }

    var price = this.priceSummary.discount_price - this.priceSummary.price;
    price = price.toFixed(2);
    if (price != null) {
      return this.Currency.getFormattedPrice(price);
    }
    return this.Currency.getFormattedPrice(0);
  },

  hasAddonsPrice: function () {
    return this.priceSummary.add_ons_total > 0;
  },

  getAddonsTotalPrice: function () {
    var price = this.priceSummary.add_ons_total;
    if (price > 0) {
      return this.Currency.getFormattedPrice(price);
    }

    return 0;
  },

  getAddonPrice: function (addon) {
    if (addon.total_price > 0) {
      return this.Currency.getFormattedPrice(addon.total_price);
    }
    return 0;
  },

  hasDiscountedPrice: function () {
    if (
      angular.isDefined(this.priceSummary.discount_price) &&
      this.priceSummary.discount_price < this.priceSummary.price
    ) {
      return true
    }
    return false;
  },

  getTotalPriceDiscounted: function () {
    if (
      angular.isDefined(this.priceSummary.discount_price) &&
      this.priceSummary.discount_price !== null
    ) {
      return this.Currency.getFormattedPrice(this.priceSummary.discount_price);
    }
    return this.Currency.getFormattedPrice(this.priceSummary.price);
  },

  getTotalPrice: function () {
    return this.Currency.getFormattedPrice(this.priceSummary.price);
  },

  getTotalCleaningPrice: function () {
    return this.Currency.getFormattedPrice(this.priceSummary.regular_fee);
  },

  hasCleaningPrice: function () {
    return this.priceSummary.regular_fee > 0;
  },

  getTranslationFromAgreementByCurrentLang: function(translations) {
    if (translations && translations.length) {
      var translation = translations.find(function(translation) {
        return translation.language.toLowerCase().toString() === (this.language ? this.language.toLowerCase().toString() : null);
      }.bind(this));

      if (angular.isUndefined(translation)) {
        translation = translations.find(function(translation) {
          return translation.language.toLowerCase().toString() === 'en';
        });
      }
      return angular.isDefined(translation) ? translation : null;
    }
    return null;
  },

  getRegulations: function () {
    var items = this.ConfigBookingEngine.getRegulationItems();
    if (items === null) {
      return false;
    }

    var item = items.find(function(item) {
      return item.regulationType === 0;
    });
    if (angular.isDefined(item)) {
      let translation = this.getTranslationFromAgreementByCurrentLang(item.translations);
      if (translation) {
        item.name = translation.name ? translation.name : null;
        item.content = translation.content ? translation.content : null;
      }
      return item;
    }
    return null;
  },

  getPrivacyPolicy: function () {
    var items = this.ConfigBookingEngine.getRegulationItems();
    if (items === null) {
      return false;
    }

    var item = items.find(function(item) {
      return item.regulationType === 1;
    });
    if (angular.isDefined(item)) {
      let translation = this.getTranslationFromAgreementByCurrentLang(item.translations);
      if (translation) {
        item.name = translation.name ? translation.name : null;
        item.content = translation.content ? translation.content : null;
      }
      return item;
    }
    return null;
  },

  getRegulationsAndPrivacyPolicy: function () {
    var items = this.ConfigBookingEngine.getRegulationItems();
    if (items === null) {
      return false;
    }

    var item = items.find(function(item) {
      return item.regulationType === 2;
    });
    if (angular.isDefined(item)) {
      let translation = this.getTranslationFromAgreementByCurrentLang(item.translations);
      if (translation) {
        item.name = translation.name ? translation.name : null;
        item.content = translation.content ? translation.content : null;
      }
      return item;
    }
    return null;
  },

  getMarketingItems: function () {
    var items = this.ConfigBookingEngine.getRegulationItems();
    if (items === null) {
      return false;
    }

    var itemsFiltered = items.filter(function(item) {
      return item.regulationType === 3;
    });
    if (itemsFiltered && itemsFiltered.length) {
      angular.forEach(itemsFiltered, function (item) {
        let translation = this.getTranslationFromAgreementByCurrentLang(item.translations);
        if (translation) {
          item.name = translation.name ? translation.name : null;
          item.content = translation.content ? translation.content : null;
        }
      }.bind(this));
      return itemsFiltered;
    }
    return null;
  },

  getMarketing: function (id) {
    var items = this.ConfigBookingEngine.getRegulationItems();
    if (items === null) {
      return false;
    }

    var item = items.find(function(item) {
      return item.id == id;
    });
    if (angular.isDefined(item)) {
      let translation = this.getTranslationFromAgreementByCurrentLang(item.translations);
      if (translation) {
        item.name = translation.name ? translation.name : null;
        item.content = translation.content ? translation.content : null;
      }
      return item;
    }
    return null;
  },

  cutHtmlSings: function(stringWithHtml) {
    return stringWithHtml ? stringWithHtml.replace(/<[^>]*>?/gm, '') : null;
  },

  isValidUrl: function (urlString) {
    var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
    '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
    return urlString ? Boolean(urlPattern.test(this.cutHtmlSings(urlString))) : null;
  },

  getAccommodationPriceWithoutDiscount: function () {
    var price = this.priceSummary.accommodation_price;
    if (price > 0) {
      return this.Currency.getFormattedPrice(price);
    }
    return 0;
  },

  getAccommodationPrice: function () {
    if (
      angular.isDefined(this.priceSummary.discount_accommodation_price) &&
      this.priceSummary.discount_accommodation_price !== null
    ) {
      return this.Currency.getFormattedPrice(
        this.priceSummary.discount_accommodation_price
      );
    }
    return this.Currency.getFormattedPrice(
      this.priceSummary.accommodation_price
    );
  },

  getAdvancePrice: function () {
    return this.Currency.getFormattedPrice(this.priceSummary.advance);
  },

  getCompanyName: function () {
    return this.ConfigHotel.getCompanyName();
  },

  getGatewayImage: function (factoryName) {
    switch (factoryName) {
      case "offline":
        return "/be/assets/img/payments/offline.jpg";
      case "paypal_express_checkout":
        return "/be/assets/img/payments/paypal.png";
      case "paypal":
        return "/be/assets/img/payments/paypal.png";
      case "payu":
        return "/be/assets/img/payments/payu.jpg";
      case "dotpay":
        return "/be/assets/img/payments/dotpay.jpg";
      case "authorize_net_aim":
        return "/be/assets/img/payments/authorize-net.jpg";
      case "payzen":
        return "/be/assets/img/payments/payzen.png";
      case "eservice":
        return "/be/assets/img/payments/eservice.png";
      case "payeezy":
        return "/be/assets/img/payments/payeezy.png";
      case "espago":
        return "/be/assets/img/payments/espago.png";
      case "przelewy24":
        return "/be/assets/img/payments/przelewy24.png";
      case "tpay":
        return "/be/assets/img/payments/tpay.png";
      case "euplatesc":
        return "/be/assets/img/payments/euplatesc.svg";
      case "paynow":
        return "/be/assets/img/payments/paynow.svg"
      case "stripe":
        return "/be/assets/img/payments/stripe.svg"
      default:
        return "/be/assets/img/payments/offline.jpg";
    }
  },

  searchItemInOffers: function (roomId, rateplanId, personsCount, addons) {
    var offer = this.filteredOffersList.filter(function (offer) {
      return offer.room.id === roomId;
    })[0];

    if (angular.isUndefined(offer)) {
      return null;
    }

    var rateplan = offer.rateplans.filter(function (rateplan) {
      return rateplan.id === rateplanId;
    })[0];

    if (angular.isUndefined(rateplan)) {
      return null;
    }

    var price = rateplan.prices.filter(function (price) {
      return price.personsCount === personsCount;
    })[0];

    if (angular.isUndefined(price)) {
      return null;
    }

    return {
      room: offer.room,
      rateplan: rateplan,
      prices: price,
      addons: addons
    };
  },

  openAgreementModal: function (agreementType, id) {
    var $this = this;
    $this.$uibModal
      .open({
        component: "modalSimple",
        size: "lg",
        resolve: {
          title: function () {
            return $this.$translate.instant("guest.agreements." + agreementType.toUpperCase());
          },
          description: function () {
            switch (agreementType) {
              case 'regulations':
                return $this.getRegulations() ? $this.getRegulations().content : null;
              case 'privacyPolicy':
                return $this.getPrivacyPolicy() ? $this.getPrivacyPolicy().content : null;
              case 'regulationsAndPrivacyPolicy':
                return $this.getRegulationsAndPrivacyPolicy() ? $this.getRegulationsAndPrivacyPolicy().content : null;
              case 'marketing':
                return $this.getMarketing(id) ? $this.getMarketing(id).content : null;
            }
          },
        },
      })
      .result.then(
        function () { },
        function () { }
      );
  },

  getAgeCategoryTranslation: function (id) {
    var ageCategory = this.ageCategories.find(function (category) {
      return category.id === id;
    });
    return ageCategory.name;
  },

  getYear: function (date) {
    return moment(date).year();
  },

  getMonth: function (date) {
    var monthIndex = moment(date).month();
    var monthList = [
      this.$translate.instant("months_short.JAN"),
      this.$translate.instant("months_short.FEB"),
      this.$translate.instant("months_short.MAR"),
      this.$translate.instant("months_short.APR"),
      this.$translate.instant("months_short.MAY"),
      this.$translate.instant("months_short.JUN"),
      this.$translate.instant("months_short.JUL"),
      this.$translate.instant("months_short.AUG"),
      this.$translate.instant("months_short.SEP"),
      this.$translate.instant("months_short.OCT"),
      this.$translate.instant("months_short.NOV"),
      this.$translate.instant("months_short.DEC"),
    ];
    return monthList[monthIndex];
  },

  getDayNumber: function (date) {
    var day = moment(date).date();
    return day < 10 ? "0" + day : day;
  },

  goToPreviousStep: function () {

    if (this.addons.length === 0) {
      this.$state.go("booking.offers", {
        checkIn: moment(this.checkIn).format("YYYY-MM-DD"),
        checkOut: this.checkOut,
        occupancy: encodeURIComponent(angular.toJson(this.occupancy)),
        discountCode: this.discountCode,
        viewType: this.viewType
      });
    } else {
      this.$state.go("booking.addons", {
        checkIn: moment(this.checkIn).format("YYYY-MM-DD"),
        checkOut: this.checkOut,
        occupancy: encodeURIComponent(angular.toJson(this.occupancy)),
        cart: encodeURIComponent(angular.toJson(this.cart)),
        discountCode: this.discountCode,
        viewType: this.viewType
      });
    }
  },

  getGuestDataForApi: function () {
    var guest = {
      surname: this.guest.fullName,
      email: this.guest.email,
      phone: this.guest.phone,
      city: this.guest.city,
      street: this.guest.street,
      postal_code: this.guest.postal_code,
      country: this.guest.country,
      firm: false,
    };

    if (this.showInvoiceForm) {
      guest.company = {
        surname: this.guest.companyName,
        nip: this.guest.companyVatId,
        city: this.guest.companyCity,
        street: this.guest.companyStreet,
        postal_code: this.guest.companyPostalCode
      };
    }
    return guest;
  },

  getItemsForApi: function () {
    var ageGroups = this.ConfigBookingEngine.getAgeCategories();
    var result = [];
    var items = this.cart;
    var addons = this.addons;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      /* eslint-disable camelcase */
      var categories = []; var add_ons = [];
      for (var j = 0; j < item.categories.length; j++) {
        categories.push({ age_category_id: ageGroups[j].id, count: item.categories[j] });
      }

      for (var j = 0; j < addons.length; j++) {
        var addon = addons[j];
        if (i == 0 || addon.priceMode == 3) {
          add_ons.push({ add_on_id: addon.id, count: addon.quantity });
        }
      }

      result.push({
        group_id: item.roomId,
        rateplan_id: item.rateplanId,
        persons_count: item.persons,
        age_counts: categories,
        add_ons: add_ons
      });
      /* eslint-enable camelcase */
    }
    return result;
  },

  getItemsForApiGet: function () {
    var url = "";
    var items = this.cart;
    var ageGroups = this.ConfigBookingEngine.getAgeCategories();
    var addons = this.addons;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      url +=
        "items[" +
        i +
        "][group_id]=" +
        item.roomId +
        "&items[" +
        i +
        "][rateplan_id]=" +
        item.rateplanId +
        "&items[" +
        i +
        "][persons_count]=" +
        item.persons;

      for (var j = 0; j < item.categories.length; j++) {
        url += `&items[${i}][age_counts][${ageGroups[j].id}]=${item.categories[j]}`
      }

      for (var j = 0; j < addons.length; j++) {
        var addon = addons[j];
        if (i == 0 || addon.priceMode == 3) {
          url += `&items[${i}][add_ons][${addon.id}]=${addon.quantity}`;
        }
      }

      if (i < items.length - 1) {
        url += "&";
      }
    }
    return url.trim();
  },

  goToNextStep: function () {
    var $this = this;
    var paymentTab;
    if ("parentIFrame" in window) {
      paymentTab = $this.$window.open(
        $this.$state.href("booking.payment-redirect"),
        "_blank"
      );
    }
    $this.$rootScope.$emit("startLoading", {
      title: $this.$translate.instant("loader.PLEASE_WAIT"),
      description: $this.$translate.instant("loader.SAVE_RESERVATION"),
    });
    /* eslint-disable camelcase */
    var requestParams = {
      start: moment($this.checkIn).format("YYYY-MM-DD"),
      end: moment($this.checkOut).subtract(1, "day").format("YYYY-MM-DD"),
      hotel_id: $this.hotelId,
      language: $this.language,
      currency: $this.Currency.getCurrency(),
      guest: $this.getGuestDataForApi(),
      comments: $this.comments,
      items: $this.getItemsForApi(),
      payment_gateway_name: $this.gatewayName,
      discount_code_name: $this.discountCode,
    };

    /* eslint-enable camelcase */
    $this.Restangular.all("bookingengine/api/be/orders")
      .post(requestParams)
      .then(function (response) {
        $this.GTMManager.setPurchaseEvent(response.reservation_id, $this.filteredOffersList);
        if (angular.isDefined(paymentTab)) {
          paymentTab.location = response.target_url;
          $this.$state.go("booking.payment-status", {
            token: response.payment_id,
          });
        } else {
          $this.$window.open(response.target_url, "_self");
        }
      })
      .catch(function (error) {
        if (angular.isDefined(paymentTab)) {
          paymentTab.location = $this.$state.href(
            "booking.clientErrors",
            {
              code: error.data.code,
            },
            { absolute: true }
          );
        }
        $this.$state.go(
          "booking.clientErrors",
          {
            code: error.data.code,
          },
          { location: false }
        );
        $this.$rootScope.$emit("stopLoading");
      });
  },
};